// modal.component.ts
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'modal-avisos-nf.component',
  templateUrl: './modal-avisos-nf.component.html',
  styleUrls: ['./modal-avisos-nf.component.css']
})
export class ModalAvisosNfComponent {
  constructor(public dialogRef: MatDialogRef<ModalAvisosNfComponent>) {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
